<div class="row">
  <div class="col-sm-4">
    <div class="row bloque mi">
      <div class="col-md-12">
        <h3 class="card-title title"><b>Customer Information</b></h3>
        <hr />

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="bmd-label-floating"><b>Company Name</b></label>
              <input
                type="txt"
                name="contactcompany"
                [(ngModel)]="so.contactcompany"
                class="form-control fctrl"
                disabled
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="bmd-label-floating"><b>Address 1</b></label>
              <input
                type="txt"
                name="contactaddress1"
                [(ngModel)]="so.contactaddress1"
                class="form-control fctrl"
                disabled
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="bmd-label-floating"><b>Address 2</b></label>
              <input
                type="txt"
                name="contactaddress2"
                [(ngModel)]="so.contactaddress2"
                class="form-control fctrl"
                disabled
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="bmd-label-floating"><b>City</b></label>
              <input
                type="txt"
                name="contactcity"
                [(ngModel)]="so.contactcity"
                class="form-control fctrl"
                disabled
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-8">
            <div class="form-group">
              <label class="bmd-label-floating"><b>State</b></label>
              <input
                type="txt"
                name="contactstate"
                [(ngModel)]="so.contactstate"
                class="form-control fctrl"
                disabled
              />
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group">
              <label class="bmd-label-floating"><b>Postal Code</b></label>
              <input
                type="txt"
                name="contactzip"
                [(ngModel)]="so.contactpostalcode"
                class="form-control fctrl"
                disabled
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="bmd-label-floating"><b>Country</b></label>
              <input
                type="txt"
                name="contaccountry"
                [(ngModel)]="so.contaccountry"
                class="form-control fctrl"
                disabled
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="bmd-label-floating"><b>Contact</b></label>
              <input
                type="txt"
                name="contactcontact"
                [(ngModel)]="so.contactcontact"
                class="form-control fctrl"
                disabled
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="bmd-label-floating"><b>Phone</b></label>
              <input
                type="txt"
                name="phone"
                [(ngModel)]="so.contactphone"
                class="form-control fctrl"
                disabled
              />
            </div>
          </div>

          <!-- <div class="col-md-6">
            <div class="form-group">
              <label class="bmd-label-floating"><b>Fax</b></label>
              <input type="txt" name="fax" [(ngModel)]="so.contactfax" class="form-control fctrl" disabled>
            </div>
          </div>
        </div> -->
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="bmd-label-floating"><b>Email</b></label>
              <input style="margin-bottom: 85px;"
                type="txt"
                name="mail"
                [(ngModel)]="so.contactemail"
                class="form-control fctrl"
                disabled
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-sm-4">
    <div class="row bloque mi">
      <div class="col-md-12">
        <h3 class="card-title title"><b>Shipping from</b></h3>
        <hr />

        <div class="row" *ngIf="so.shipfromlocation_id !== null || edit">
          <div class="col-md-6">
            <div class="form-group">
              <label class="bmd-label-floating"><b>Location</b></label>
              <select
                name="shipfromlocation_id"
                [(ngModel)]="so.shipfromlocation_id"
                (change)="selectLocationFrom()"
                class="form-control fctrl"
                [disabled]="!edit"
                required
              >
                <option value="null" disabled>Select Location</option>
                <option
                  *ngFor="let location of userLocations"
                  [value]="location.id"
                >
                  {{ location.name }}
                </option>
                <option value="headq">Headquarters</option>
                <option value="new">New Address</option>
                <option value="other">One Time</option>
              </select>
            </div>
          </div>

          <div class="col-md-6" *ngIf="so.shipfromlocation_id === 'new'">
            <div class="form-group">
              <label class="bmd-label-floating"><b>Location's name</b></label>
              <input
                type="txt"
                name="shipfromname"
                [(ngModel)]="so.shipfromname"
                class="form-control fctrl"
                [disabled]="!edit"
                required
              />
            </div>
          </div>
        </div>

        <!-- <div class="row" *ngIf="edit">
            <div class="col-md-12">
              <label class="bmd-label-float</b>ing"><b>
                <input type="checkbox" name="dfFromLocation" [(ngModel)]="so.setDefaultFromLocation">
                  Set Default Location
              </label>
            </div>
          </div> -->

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="bmd-label-floating"><b>Company</b></label>
              <input
                type="txt"
                name="shipfromcompany"
                [(ngModel)]="so.shipfromcompany"
                class="form-control fctrl"
                [disabled]="!edit"
                required
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="bmd-label-floating"><b>Address</b></label>
              <input
                type="txt"
                name="shipfromaddress1"
                [(ngModel)]="so.shipfromaddress1"
                class="form-control fctrl"
                [disabled]="!edit"
                required
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="bmd-label-floating"><b>Address 2</b></label>
              <input
                type="txt"
                name="shipfromaddress2"
                [(ngModel)]="so.shipfromaddress2"
                class="form-control fctrl"
                [disabled]="!edit"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="bmd-label-floating"><b>City</b></label>
              <input
                type="txt"
                name="shipfromcity"
                [(ngModel)]="so.shipfromcity"
                class="form-control fctrl"
                [disabled]="!edit"
                required
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-8">
            <div class="form-group">
              <label class="bmd-label-floating"><b>State</b></label>
              <input
                type="txt"
                name="shipfromstate"
                [(ngModel)]="so.shipfromstate"
                class="form-control fctrl"
                [disabled]="!edit"
                required
              />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label class="bmd-label-floating"><b>Postal Code</b></label>
              <input
                type="txt"
                name="shipfrompostalcode"
                [(ngModel)]="so.shipfrompostalcode"
                class="form-control fctrl"
                [disabled]="!edit"
                required
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="bmd-label-floating"><b>Country</b></label>
              <input
                type="txt"
                name="shipfromcountry"
                [(ngModel)]="so.shipfromcountry"
                class="form-control fctrl"
                [disabled]="!edit"
                required
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="bmd-label-floating"><b>Contact</b></label>
              <input
                type="txt"
                name="shipfromcontact"
                [(ngModel)]="so.shipfromcontact"
                class="form-control fctrl"
                [disabled]="!edit"
                required
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="bmd-label-floating"><b>Phone</b></label>
              <input
                type="txt"
                name="shipfromphone"
                [(ngModel)]="so.shipfromphone"
                class="form-control fctrl"
                [disabled]="!edit"
                required
              />
            </div>
          </div>
          <!-- <div class="col-md-6">
              <div class="form-group">
              <label class="bmd-label-floating"><b>Fax</b></label>
              <input type="txt" name="shipfromfax" [(ngModel)]="so.shipfromfax" class="form-control fctrl"
                [disabled]="!edit">
              </div>
            </div> -->
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="bmd-label-floating"><b>Email</b></label>
              <input
                type="txt"
                name="shipfromemail"
                [(ngModel)]="so.shipfromemail"
                class="form-control fctrl"
                [disabled]="!edit"
                required
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-sm-4">
    <div class="row bloque mi">
      <div class="col-md-12">
        <h3 class="card-title title"><b>Shipping to</b></h3>
        <hr />

        <div class="row" *ngIf="so.shiptolocation_id !== null || edit">
          <div class="col-md-6">
            <div class="form-group">
              <label class="bmd-label-floating"><b>Company Location</b></label>
              <select
                name="shiptolocation_id"
                [(ngModel)]="so.shiptolocation_id"
                (change)="selectLocatioTo()"
                class="form-control fctrl"
                [disabled]="!edit"
                required
              >
                <option value="null" disabled>Select Location</option>
                <option
                  *ngFor="let location of locations"
                  [value]="location.id"
                >
                  {{ location.name }}
                </option>
                <option value="headq">Headquarters</option>
                <option value="new">New Address</option>
                <option value="other">One Time</option>
              </select>
            </div>
          </div>

          <div class="col-md-6" *ngIf="so.shiptolocation_id === 'new'">
            <div class="form-group">
              <label class="bmd-label-floating"><b>Location's name</b></label>
              <input
                type="txt"
                name="shiptoname"
                [(ngModel)]="so.shiptoname"
                class="form-control fctrl"
                [disabled]="!edit"
                required
              />
            </div>
          </div>
        </div>

        <!-- <div class="row" *ngIf="edit">
            <div class="col-md-12">
              <label class="bmd-label-float</b>ing"><b>
              <input type="checkbox" name="dfToLocation" [(ngModel)]="so.setDefaultToLocation"> Set
                Default Location
              </label>
            </div>
          </div> -->

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="bmd-label-floating"><b>Company</b></label>
              <input
                type="txt"
                name="shiptocompany"
                [(ngModel)]="so.shiptocompany"
                class="form-control fctrl"
                [disabled]="!edit"
                required
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="bmd-label-floating"><b>Address</b></label>
              <input
                type="txt"
                name="shiptoaddress1"
                [(ngModel)]="so.shiptoaddress1"
                class="form-control fctrl"
                [disabled]="!edit"
                required
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="bmd-label-floating"><b>Address 2</b></label>
              <input
                type="txt"
                name="shiptoaddress2"
                [(ngModel)]="so.shiptoaddress2"
                class="form-control fctrl"
                [disabled]="!edit"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="bmd-label-floating"><b>City</b></label>
              <input
                type="txt"
                name="shiptocity"
                [(ngModel)]="so.shiptocity"
                class="form-control fctrl"
                [disabled]="!edit"
                required
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-8">
            <div class="form-group">
              <label class="bmd-label-floating"><b>State</b></label>
              <input
                type="txt"
                name="shiptostate"
                [(ngModel)]="so.shiptostate"
                class="form-control fctrl"
                [disabled]="!edit"
                required
              />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label class="bmd-label-floating"><b>Postal Code</b></label>
              <input
                type="txt"
                name="shiptopostalcode"
                [(ngModel)]="so.shiptopostalcode"
                class="form-control fctrl"
                [disabled]="!edit"
                required
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="bmd-label-floating"><b>Country</b></label>
              <input
                type="txt"
                name="shiptocountry"
                [(ngModel)]="so.shiptocountry"
                class="form-control fctrl"
                [disabled]="!edit"
                required
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="bmd-label-floating"><b>Contact</b></label>
              <input
                type="txt"
                name="shiptocontact"
                [(ngModel)]="so.shiptocontact"
                class="form-control fctrl"
                [disabled]="!edit"
                required
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="bmd-label-floating"><b>Phone</b></label>
              <input
                type="txt"
                name="shiptophone"
                [(ngModel)]="so.shiptophone"
                class="form-control fctrl"
                [disabled]="!edit"
                required
              />
            </div>
          </div>
          <!-- <div class="col-md-6">
              <div class="form-group">
                <label class="bmd-label-floating"><b>Fax</b></label>
                <input type="txt" name="shiptofax" [(ngModel)]="so.shiptofax" class="form-control fctrl"
                  [disabled]="!edit">
              </div>
            </div> -->
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="bmd-label-floating"><b>Email</b></label>
              <input
                type="txt"
                name="shiptoemail"
                [(ngModel)]="so.shiptoemail"
                class="form-control fctrl"
                [disabled]="!edit"
                required
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
